import { apiHolder, apis } from 'api';
import { edmOperateVarSubjectN } from '@web-mail-write/components/SendMail/utils';
const edmApi = apiHolder.api.requireLogicalApi(apis.edmSendBoxApiImpl);
const eventApi = apiHolder.api.getEventApi();
let taskId;
const query = async (req) => {
    req.contentList = req.contentList.map(i => (Object.assign(Object.assign({}, i), { content: edmOperateVarSubjectN(i.content) })));
    const res = await edmApi.getGPTAiContentRefresh(req);
    taskId = res.taskId;
    if (res.finishState === 0) {
        return await new Promise((resolve, reject) => {
            try {
                setTimeout(async () => {
                    const res = await query(Object.assign(Object.assign({}, req), { taskId, first: false }));
                    resolve(res);
                }, 1500);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    else if (res.finishState === 1) {
        return res;
    }
    else {
        throw new Error('生成失败，请重试！');
    }
};
export const aiModSubject = async (theme, size, type) => {
    if (size < 1 || size > 5) {
        return theme;
    }
    const { dayLeft } = await edmApi.getGPTQuota();
    if (dayLeft !== -1 && dayLeft < 1) {
        throw new Error('今日剩余次数不足');
    }
    const res = await query({
        size,
        contentList: theme.map(item => ({ content: item })),
        type,
        first: true,
    });
    if (res.aiContentInfos == null || res.aiContentInfos.length === 0) {
        return theme;
    }
    if (type === 3) {
        return res.aiContentInfos[0].aiContentList.map(info => info.aiContent.trim() || theme[0]);
    }
    return theme.map(item => {
        let info = res.aiContentInfos.find(info => info.content === item);
        return (info === null || info === void 0 ? void 0 : info.aiContentList) ? info === null || info === void 0 ? void 0 : info.aiContentList[0].aiContent : item;
    });
};
export const aiTimesSubtract = () => {
    try {
        eventApi.sendSysEvent({ eventName: 'aiTimesUpdate' });
    }
    catch (err) {
    }
};
